import React from "react";

const HighestRevenue = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        width="55.7828"
        height="55.7828"
        rx="27.8914"
        fill="#605BFF"
      />
      <mask
        id="mask0_98_5052"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="15"
        y="15"
        width="25"
        height="25"
      >
        <path
          d="M15.8271 15.6958H39.8271V39.6958H15.8271V15.6958Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_98_5052)">
        <mask
          id="mask1_98_5052"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="16"
          y="15"
          width="25"
          height="25"
        >
          <rect x="16.0527" y="15.9645" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask1_98_5052)">
          <path
            d="M28.0527 26.652C28.7746 26.652 29.3926 26.395 29.9066 25.8809C30.4207 25.3669 30.6777 24.7489 30.6777 24.027C30.6777 23.3051 30.4207 22.6872 29.9066 22.1731C29.3926 21.659 28.7746 21.402 28.0527 21.402C27.3309 21.402 26.7129 21.659 26.1988 22.1731C25.6848 22.6872 25.4277 23.3051 25.4277 24.027C25.4277 24.7489 25.6848 25.3669 26.1988 25.8809C26.7129 26.395 27.3309 26.652 28.0527 26.652ZM23.3074 38.4645V37.152H27.3965V32.2252C26.2404 32.0181 25.2287 31.5346 24.3613 30.7749C23.494 30.0152 22.897 29.0734 22.5704 27.9494C21.1822 27.7862 19.9989 27.217 19.0204 26.2419C18.042 25.2667 17.5527 24.0909 17.5527 22.7145V21.402C17.5527 21.0503 17.6835 20.7436 17.9452 20.4819C18.2068 20.2203 18.5135 20.0895 18.8652 20.0895H22.3483V17.4645H33.7572V20.0895H37.2402C37.592 20.0895 37.8987 20.2203 38.1603 20.4819C38.4219 20.7436 38.5527 21.0503 38.5527 21.402V22.7145C38.5527 24.0909 38.0635 25.2667 37.085 26.2419C36.1066 27.217 34.9232 27.7862 33.535 27.9494C33.2085 29.0734 32.6115 30.0152 31.7441 30.7749C30.8768 31.5346 29.8651 32.0181 28.709 32.2252V37.152H32.7981V38.4645H23.3074ZM22.3483 26.5411V21.402H18.8652V22.7145C18.8652 23.714 19.1984 24.5726 19.8647 25.2903C20.531 26.008 21.3589 26.4249 22.3483 26.5411ZM28.0527 30.9429C29.2642 30.9429 30.2907 30.5222 31.1322 29.6809C31.9735 28.8396 32.3942 27.8131 32.3942 26.6015V18.777H23.7113V26.6015C23.7113 27.8131 24.132 28.8396 24.9733 29.6809C25.8148 30.5222 26.8413 30.9429 28.0527 30.9429ZM33.7572 26.5411C34.7466 26.4249 35.5745 26.008 36.2408 25.2903C36.9071 24.5726 37.2402 23.714 37.2402 22.7145V21.402H33.7572V26.5411Z"
            fill="#605BFF"
          />
        </g>
      </g>
    </svg>
  );
};

export default HighestRevenue;
